import BrowserInteractionTime from 'browser-interaction-time';

import routes from 'sitewide-js/core_pre_webpack/routes';
import { keptAlivePost } from 'js/utils';

export function startTimeTracking() {
  if (
    !(
      'navigator' in window &&
      'sendBeacon' in window.navigator &&
      'performance' in window
    )
  ) {
    return;
  }
  const browserInteractionTime = new BrowserInteractionTime({
    idleTimeoutMs: 60000,
  });
  browserInteractionTime.startTimer();

  let maxClientHeight = 0;
  let maxScroll = 0;

  function updateHeightAndScroll() {
    maxClientHeight = Math.max(maxClientHeight, document.body.clientHeight);
    maxScroll = Math.max(maxScroll, window.scrollY);
  }

  window.setInterval(updateHeightAndScroll, 1000);

  window.addEventListener('pagehide', (event) => {
    // Persisted means page is entering frozen state.
    // See https://developer.chrome.com/articles/page-lifecycle-api/ for details.
    if (event.persisted) return;

    const hitId = (window.Aedu && Aedu.hit_data && Aedu.hit_data.id) || null;
    updateHeightAndScroll();
    const url = routes.api_v0_record_page_view_path({ subdomain_param: 'api' });
    const data = {
      hit_id: hitId,
      duration: browserInteractionTime.getTimeInMilliseconds(),
      max_client_height: maxClientHeight,
      max_scroll: maxScroll,
    };
    keptAlivePost(url, data);
  });
}
